<template>
  <div class="page-container">
    <Sidebar />
    <div class="main-content">
      <AdminTable
        title="越鲜公司管理"
        :apiEndpoint="apiEndpoint"
        :columns="columns"
        :formFields="formFields"
      />
    </div>
  </div>
</template>

<script>
import AdminTable from '@/components/AdminTable.vue'
import Sidebar from '../components/Sidebar.vue'

export default {
  name: 'XianxianCompaniesList',
  components: { AdminTable, Sidebar },
  data() {
    return {
      apiEndpoint: '/api/admin/xianxian-companies',
      columns: [
        { key: 'id', label: 'ID' },
        { key: 'name', label: '公司名' },
        { key: 'address', label: '地址' },
        { key: 'created_at', label: '时间', type: 'date' }
      ],
      formFields: [
        { key: 'name', label: '公司名', type: 'text', required: true },
        { key: 'address', label: '地址', type: 'text', required: true }
      ]
    }
  }
}
</script>

<style scoped>
.page-container {
  display: flex;
  min-height: 100vh;
  background: #f5f5f5;
}
.main-content {
  flex: 1;
  margin-left: 260px;
  padding: 20px;
}
</style>
